import React, { createContext, useContext, useMemo, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import routes from "./routes/routes";
import { CssBaseline, Stack } from "@mui/material";
import lightTheme from "./theme/lightTheme";
import darkTheme from "./theme/darkTheme";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import "./App.css";
import PathLayout from "./components/common/PathLayout";
import { Provider } from "react-redux";
import { persist, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import TopBar from "./components/common/TopBar";
import AppRoutes from "./routes/AppRoutes";

const UserContext = createContext();

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isOpen, setIsOpen] = useState(true); // Add state for sidebar
  const [mode, setMode] = useState(
    localStorage.getItem("mode") === "dark" ? "dark" : "light"
  );

  // Toggle between light and dark themes
  const theme = useMemo(() => {
    return mode === "light" ? lightTheme : darkTheme;
  }, [mode]);

  const toggleTheme = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("mode", newMode);
  };
  const ENABLE_LOGS = process.env.REACT_APP_ENABLE_LOGS === "false";

  if (ENABLE_LOGS) {
    console.log = () => {};
    console.warn = () => {};
  }

  return (
    <Provider store={store}>
      <PersistGate persistor={persist}>
        <UserContext.Provider
          value={{ isAuthenticated, setIsAuthenticated, isOpen, setIsOpen }}
        >
          <MUIThemeProvider theme={theme}>
            <CssBaseline />

            <Router>
              <PathLayout theme={theme} toggleTheme={toggleTheme}>
                <Stack sx={{ display: "flex" }}>
                  <AppRoutes routes={routes} />
                </Stack>
              </PathLayout>
            </Router>
          </MUIThemeProvider>
        </UserContext.Provider>
      </PersistGate>
    </Provider>
  );
};

export default App;

export const useUserContext = () => useContext(UserContext);
